import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import colors from "@constants/colors"
import { body14Styles, body16BoldStyles } from "@constants/typography"
import React from "react"
import styled, { css } from "styled-components"

const Container = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  padding: 20px 16px;
  border: 1px solid ${colors.dividerLineGray};
  border-radius: 6px;
`

export const ImageWrapper = styled.div<{ hoverType?: string }>`
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  width: 64px;
  height: 64px;

  ${ImageHelperContainer} {
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    height: auto;

    img {
      object-fit: contain;
    }
  }
`

const Content = styled.div`
  width: 100%;
  margin-left: 16px;
`

const Row = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  display: flex;
`

const ProductName = styled.div`
  ${body16BoldStyles}
  margin-bottom: 8px;
`

const Price = styled.div<{ discountedPrice: boolean }>`
  ${({ discountedPrice }) => css`
    ${body14Styles}
    color: ${discountedPrice ? colors.black : colors.mediumGray};
  `}
`

const DiscountedPrice = styled.div`
  ${body14Styles}
  margin-right: 8px;
  text-decoration: line-through;
  color: ${colors.mediumGray};
`

export interface BlockProps {
  discountedPrice?: string
  image: string
  onClick: any
  price: string
  productName: string
}

const Block: React.FC<BlockProps> = ({
  discountedPrice,
  image,
  onClick,
  price,
  productName,
}) => {
  const showDiscountedPrice = Boolean(
    discountedPrice && discountedPrice !== price
  )

  return (
    <Container
      onClick={(e) => {
        e.stopPropagation()
        if (onClick) onClick()
      }}
    >
      <Row>
        <ImageWrapper>
          <ImageHelper src={image} />
        </ImageWrapper>
        <Content>
          <ProductName>{productName}</ProductName>
          <Row>
            {showDiscountedPrice && (
              <DiscountedPrice>{`$${discountedPrice}`}</DiscountedPrice>
            )}
            <Price discountedPrice={!!discountedPrice}>{`$${price}`}</Price>
          </Row>
        </Content>
      </Row>
    </Container>
  )
}

export default Block
